module.exports = __webpack_public_path__ + "img/icon-profile-input-edit.710fc762.svg";